export default __webpack_public_path__ + "static/media/KZ.M.09.2201.0189d823.svg";